function PurchaseHistoryIcon({ white = false }: { white?: boolean }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_2200_9576)">
				<g>
					<path
						d="M1.92417 0.9375V4.62502M1.92417 4.62502H5.61169M1.92417 4.62502C3.19936 2.42062 5.58272 0.9375 8.31253 0.9375H15.6875C19.7606 0.9375 23.0625 4.23938 23.0625 8.31248V15.6875C23.0625 19.7606 19.7606 23.0625 15.6875 23.0625H8.31253C4.23942 23.0625 0.9375 19.7606 0.9375 15.6875V12M15.6875 15.6875L12 12V6.46875"
						stroke={white ? "white" : "#4D5561"}
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_2200_9576">
					<rect width="24" height="24" fill={white ? "white" : "#4D5561"} />
				</clipPath>
			</defs>
		</svg>
	);
}

export default PurchaseHistoryIcon;
